interface Props {
  children: string;
  /** Box the label is centred in */
  width: string;
  height: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Text read bottom-to-top. Built with a rotated horizontal span instead of
 * `writing-mode`, which html2canvas (PDF export) does not render.
 */
export function VerticalText({ children, width, height, className, style }: Props) {
  return (
    <div className="relative shrink-0" style={{ width, height }}>
      <span
        className={`absolute left-1/2 top-1/2 whitespace-nowrap ${className ?? ''}`}
        style={{ transform: 'translate(-50%, -50%) rotate(-90deg)', ...style }}
      >
        {children}
      </span>
    </div>
  );
}
